
export const MSG_PLEASE_CHECK = 'Bitte überprüfen Sie Ihre Eingaben.';
